module.exports = __webpack_public_path__ + "static/Rock-Logo-white-c2b902d263def1ac3cf6935b3098e1f2.png";